import React from 'react';
import { Container } from '../styles/center';

const About = () => {
  return (
    <Container>
      <h1>Adatvédelem</h1>
    </Container>
  );
};

export default About;
